// external
import React from 'react';
import * as Yup from 'yup';

import AddAccountFormContainer from '../../AddAccountFormContainer';
import CurrencyInput from 'src/components/formik-fields/currency-input/CurrencyInput';
import BasicInput from 'src/components/formik-fields/basic-input/BasicInput';
import PercentInput from 'src/components/formik-fields/percent-input/PercentInput';
import { AddAccountFormViewModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import LiteralsService from 'src/services/literals/LiteralsService';
import { InvestmentHoldingSubtype, InvestmentHoldingType } from 'src/types/investment-holding.model';

export default function SavingAccountForm({
    manualAccount,
    onSubmit,
    handleBack
}: AddAccountFormViewModel): JSX.Element {
    return (
        <AddAccountFormContainer
            initialValues={{
                name: '',
                amount: '',
                interest: 0
            }}
            validationSchema={Yup.object({
                name: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
                amount: Yup.number()
                    .required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull'))
                    .typeError(LiteralsService.getLiteral('Onboarding.forms.inputValidationTypeNumber')),
                interest: Yup.number()
                    .moreThan(0, LiteralsService.getLiteral('FormErrors.amountGreaterThanZero'))
                    .required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull'))
                    .typeError(LiteralsService.getLiteral('Onboarding.forms.inputValidationTypeNumber'))
            })}
            manualAccount={manualAccount}
            onSubmit={(values) => {
                void onSubmit(
                    values,
                    manualAccount,
                    false,
                    InvestmentHoldingType.Cash,
                    InvestmentHoldingSubtype.SavingAccount
                );
            }}
            handleBack={handleBack}
        >
            <BasicInput id="name" label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.name')} />
            <CurrencyInput id="amount" label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.cashAmount')} />
            <PercentInput
                id="interest"
                showFractions
                label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.interestRate')}
            />
        </AddAccountFormContainer>
    );
}
